"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CordovaNetworkStatus = void 0;
/**
 * Cordova networks status implementation based on: cordova-plugin-network-information
 * See: https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-network-information
 */
var CordovaNetworkStatus = /** @class */ (function () {
    function CordovaNetworkStatus() {
        this.listeners = [];
        document.addEventListener("online", this.handleNetworkStatusChange.bind(this), false);
        document.addEventListener("offline", this.handleNetworkStatusChange.bind(this), false);
    }
    CordovaNetworkStatus.prototype.addListener = function (listener) {
        this.listeners.push(listener);
    };
    CordovaNetworkStatus.prototype.removeListener = function (listener) {
        var index = this.listeners.indexOf(listener);
        if (index >= 0) {
            this.listeners.splice(index, 1);
        }
    };
    CordovaNetworkStatus.prototype.isOffline = function () {
        return new Promise(function (resolve) {
            document.addEventListener("deviceready", function () {
                resolve(!window.navigator.onLine);
            }, false);
        });
    };
    CordovaNetworkStatus.prototype.handleNetworkStatusChange = function () {
        var online = window.navigator.onLine;
        this.listeners.forEach(function (listener) {
            listener({ online: online });
        });
    };
    return CordovaNetworkStatus;
}());
exports.CordovaNetworkStatus = CordovaNetworkStatus;
